
export default function MultilocationIcon({...props}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox='0 0 54.34 49.525'
            {...props}
        >
            <g transform="translate(-550 -1530.386)">
            <path
                data-name="Path 92"
                d="M588.505 1565.152c1.327.533 1.973 1.346 1.973 2.046a2.09 2.09 0 0 1-1.2 1.662 7.37 7.37 0 0 1-6.964 0 2.1 2.1 0 0 1-1.2-1.662c0-.7.644-1.509 1.965-2.042.659-1.042 5.153-1.793 5.431 0Z"
                fill="#25b39e"
            />
            <path
                data-name="Path 93"
                d="M588.831 1563.334a.937.937 0 0 0-.333 1.812c1.327.533 1.973 1.346 1.973 2.046a2.089 2.089 0 0 1-1.2 1.661 7.368 7.368 0 0 1-6.964 0 2.1 2.1 0 0 1-1.2-1.661c0-.7.644-1.509 1.965-2.042a.937.937 0 1 0-.7-1.739c-1.751.707-3.14 2.042-3.14 3.781a3.952 3.952 0 0 0 2.093 3.253 9.2 9.2 0 0 0 8.933 0 3.948 3.948 0 0 0 2.09-3.253c0-1.743-1.39-3.078-3.147-3.784a.937.937 0 0 0-.366-.073Z"
                fill="#2b4255"
            />
            <path
                data-name="Path 94"
                d="M592.347 1557.339c0 3.5-6.558 10.524-6.558 10.524s-6.558-7.022-6.558-10.524a6.562 6.562 0 0 1 13.116 0Z"
                fill="#f05542"
            />
            <path
                data-name="Path 95"
                d="m595.938 1547.164.878 1.548 1.391-.777-.966-1.607Zm-5.021 2.9.963 1.607 3.213-1.929-.966-1.607Zm-17.08 16.868.007 1.874 3.748-.019-.007-1.874Zm-4.633 3.985 1.435 1.2 2.408-2.873-1.435-1.2Zm-3.612 4.308 1.438 1.2 2.4-2.869-1.435-1.2Zm-4.754 1.548.52 1.8 3.6-1.036-.52-1.8Zm-4.681 1.343.516 1.8 2.88-.827-.516-1.8Z"
                fill="#2b4255"
                fillRule="evenodd"
            />
            <circle
                data-name="Ellipse 10"
                cx={1.874}
                cy={1.874}
                r={1.874}
                transform="translate(583.915 1555.221)"
                fill="#4bbfeb"
            />
            <path
                data-name="Path 96"
                d="M563.117 1568.581c0 3.5-6.558 10.523-6.558 10.523s-6.559-7.022-6.559-10.523a6.562 6.562 0 0 1 13.117 0Z"
                fill="#f05542"
            />
            <circle
                data-name="Ellipse 11"
                cx={1.874}
                cy={1.874}
                r={1.874}
                transform="translate(554.684 1566.464)"
                fill="#4bbfeb"
            />
            <path
                data-name="Path 97"
                d="M604.34 1536.727c0 3.5-6.558 10.524-6.558 10.524s-6.559-7.022-6.559-10.524a6.562 6.562 0 0 1 13.117 0Z"
                fill="#f05542"
            />
            <circle
                data-name="Ellipse 12"
                cx={1.874}
                cy={1.874}
                r={1.874}
                transform="translate(595.908 1534.609)"
                fill="#4bbfeb"
            />
            </g>
        </svg>
    )
}
